import { render } from "./Workorder_DBCC.vue?vue&type=template&id=3c5088f0"
import script from "./Workorder_DBCC.vue?vue&type=script&lang=js"
export * from "./Workorder_DBCC.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__